import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axiosInstance from "../../services/axiosInstance";
import { useBreadcrumbs } from "../../contexts/BreadcrumbContext";

const RefillReminders = ({ customerId }) => {
    const [reminders, setReminders] = useState([]);
    const navigate = useNavigate();
    const { push, beginDrilldown } = useBreadcrumbs();

    useEffect(() => {
        const fetchReminders = async () => {
            try {
                const response = await axiosInstance.get(`/api/refill-reminders/`, { params: { customer_id: customerId } });
                setReminders(response.data.results);
            } catch (error) {
                console.error("Failed to load reminders", error);
            }
        };

        fetchReminders();
    }, [customerId]);

    const handleRowClick = (reminder) => {
        beginDrilldown();
        navigate(`/prescriptions`, {
            state: {
                prescriptionId: reminder.prescription, // Pass the selected prescription ID
                customerId: reminder.customer // Pass the customer ID
            },
        });
        push({
            label: `Customer: ${reminder.customer_name}`,
            path: `/customers/${customerId}`,
        });
        push({
            label: `Prescriptions`,
            path: '/prescriptions',
        });
        push({
            label: `Prescription: ${reminder.prescription}`,
            path: '/prescriptions',
            state: { prescriptionId: reminder.prescription }
        });
    };

    return (
        <div className="p-4 rounded-lg shadow">
            <h3 className="text-lg font-semibold">Refill Reminders</h3>
            {reminders.length === 0 ? (
                <p>No upcoming refills.</p>
            ) : (
                <ul>
                    {reminders.map((reminder) => (
                        <li key={reminder.id} className="border-b p-2" onClick ={() => {handleRowClick(reminder)}} style={{cursor:'pointer'}}>
                            Prescription No.{reminder.prescription} - To be refilled on {reminder.refill_date}
                        </li>
                    ))}
                </ul>
            )}
        </div>
    );
};

export default RefillReminders;